module.exports = __webpack_public_path__ + "static/tc-d40761f21eebb19082ad74bd401555ee.svg";